import React from 'react'
import './Loading.css'

const Loading = () => {
    return(
        <div className="loading">
            <div>
                <div className="loader"></div>
                <p><span style={{fontSize: '700'}}>Thanks, for waiting!!</span></p>
            </div>
        </div>
    )
}
export default Loading;